import { render, staticRenderFns } from "./FSwitch.vue?vue&type=template&id=ea3f3352&"
import script from "./FSwitch.vue?vue&type=script&lang=js&"
export * from "./FSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports